import auth from '@/services/CRMinitAuth';

const list = query =>
  auth.get(`${process.env.VUE_APP_CRM_API}common/cbr_users/`, {
    params: query
  });

export default {
  list,
};